import styled from "styled-components";
import SVG from "react-inlinesvg";

export const Container = styled.button`
    align-items: center;
    align-self: center;
    background: ${props => (props.$isfocus ? '#fff' : "transparent")};
    border: ${props => (props.$isfocus ? '2px solid '+ props.color : 'none')};
    border-radius: 15px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    height: ${props => (props.$isfocus || props.$notFixed ? '180px' : '50px')};
    justify-content: space-around;
    justify-self: center;
    outline: none;
    padding: 8px 18px;
    padding-bottom: 25px;
    position: relative;
    scale: ${props => (props.$isfocus && !props.$notFixed ? '1.2' : props.$isfav ? '1' : '0.8')};
    width: 120px;
    // box-shadow: ${props => (props.$isfocus ? 'none' : '3px 3px 0px 0px'+props.color)};
    box-shadow: -1px 1px 11px 0 rgba(0, 0, 0, 0.25) inset;
    @media (min-width: 720px) {
        height: 234px;
        padding: 16px;
        width: 185px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        height: ${props => (props.$isfocus || props.$notFixed ? '180px' : '50px')};
        padding: 8px 18px;
        padding-bottom: 25px;
        width: 130px;
    }
    &:hover {
        // background: ${props => (props.$isfocus ? '#fff' : props.color)};
        border: ${props => ('2px solid '+ props.color)};
    }
`;

export const TitleContainer = styled.div`
    align-items: center;
    color: #333;
    display: flex;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    height: 50px;
    justify-content: center;
    line-height: 101.008%;
    text-align: center;
    width: 100%;
    @media (min-width: 720px) {
        font-size: 16px;
        height: auto;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        height: 50px;
        font-size: 12px;
    }

`;

export const ContentContainer = styled.div`
    display: ${props => (props.$isfocus || props.$notFixed ? 'flex' : 'none')};
    @media (min-width: 720px) {
        display: flex;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        display: ${props => (props.$isfocus || props.$notFixed? 'flex' : 'none')};
    }
`;

export const InfoContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
`

export const InfoNumber = styled.h2`
    color: #333;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    width: 100%;
    @media (min-width: 720px) {
        font-size: 25px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        font-size: 20px;
    }
`;

export const Description = styled.span`
    color: #333;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    width: 100%;
    @media (min-width: 720px) {
        font-size: 15px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        font-size: 10px;
    }
`;

export const CardPlaceHolderContainer = styled.button`
    align-items: center;
    align-self: center;
    background: transparent;
    border-color: #006560;
    border-radius: 8px;
    border-style: dashed;
    border-width: 1.8px;
    box-sizing: border-box;
    color: #333; 
    cursor: pointer;
    display: flex;
    flex-direction: column;
    font-size: ${props => (props.$isfocus ? '14px' : '12px')};
    font-weight: 700;
    gap: ${props => (props.$isfocus ? '12px' : '8px')};
    height: ${props => (props.$isfocus ? '180px' : '90px')};
    justify-content: center;
    justify-self: center;
    outline: none;
    width: 130px;
    @media (min-width: 720px) {
        font-size: 16px;
        height: 234px;
        padding: 10px;
        scale: ${props => (props.$isfav ? '1' : '0.8')};
        width: 185px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        font-size: ${props => (props.$isfocus ? '16px' : '14px')};
        height: ${props => (props.$isfocus ? '180px' : '100px')};
        padding:  ${props => (props.$isfocus ? '14px' : '4px')};
        width:  ${props => (props.$isfocus ? '140px' : '120px')};
    }

    &:hover{
        background: #F6F6F6;
        border-color: ${props => (props.$isfocus ? props.color : '#33CC99')};
    }
`;

export const SvgIcon = styled(SVG)`
    background: #FFFFFF;
    border: 1px solid #006560;
    border-radius: 50%;
    height: 24px;
    padding: 4px;
    width: 24px;
    @media (min-width: 720px) {
        height: 30px;
        padding: 6px;
        width: 30px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        height: 26px;
        padding: 4px;
        width: 26px;
    }
`;

export const ChangeIconContainer = styled.div`
    align-items: center;
    background: transparent;
    border: none;
    bottom: 0px;
    display: flex;
    color: #FFF;
    font-size: 8px;
    font-style: normal;
    font-weight: 700;
    gap: 5px;
    height: 25px;    
    justify-content: center;
    line-height: normal;
    position: absolute;
    text-align: center;
    width: 100%;
    @media (min-width: 720px) {
        font-size: 12.918px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        font-size: 8px;
    }
    border-radius: 0px 0px 15px 15px;
    box-shadow: 4px 2px 5.2px 0px rgba(0, 0, 0, 0.15) inset;
`;

export const ChangeIconSVG = styled(SVG)`
    align-self: center;
    height: 12px;
    width: 12px;
    & path {
        fill: ${({ fill }) => fill};
    }
    @media (min-width: 720px) {
        height: 20px;
        width: 20px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        height: 12px;
        width: 12px;
    }
`;

export const ContainerFavButtonMobile = styled.div`
    display: flex;
    @media (min-width: 720px) {
        display: none;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        display: flex;
    }
`;

export const FavIconContainer = styled(SVG)`
    align-self: center;
    background: #FFFFFF;
    border: 1px solid #006560;
    border-radius: 50%;
    padding: 6px;
    height: 26px;
    width: 26px;
    & path {
        fill: #006560;
    }
    &:hover{
        background: #F2F2F2;
        border-color: #33CC99;
    }
    @media (min-width: 720px) {
        height: 34px;
        width: 34px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        height: 26px;
        width: 26px;
    }
`;

export const FavButton = styled.div`
    background: transparent;
    border: none;
    cursor: pointer;
    height: 12px;
    left: -10px;
    outline: none;
    position: absolute;
    top: -10px;
    width: 12px;
    @media (min-width: 720px) {
        height: 20px;
        width: 20px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        height: 12px;
        width: 12px;
    }
`;

export const AlertContainer = styled.div`
    display: flex;
    position: absolute;
    right: 8px;
    top: 8px;
`;

export const AlertIcon = styled(SVG)`   
    height: 15px;
    width: 15px;
    & path {
        fill: ${({ color }) => color};
    }
`;